import React, { useEffect, useState } from "react";
import TextInput from "../../../../components/TextInput";
import { useLocation } from "react-router-dom";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";
import SelectHookFormSingleEmail from "../../../../components/SelectHookFormSingleEmailRecip";

const TableFilters = ({
  operationsType,
  filterText,
  filterOperation,
  moduleDetails,
  textInputName,
  setNotifVal,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [operationValue, setOperationValue] = useState(null);
  const [disableBtnSearch, setDisableBtnSearch] = useState(false);
  const [disableRefresh, setDisableRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState(undefined);
  const FilterData = () => {
    filterText(inputValue);
    filterOperation(operationValue);
  };

  useEffect(() => {
    if (inputValue !== "" || operationValue !== null) {
      setDisableBtnSearch(false);
      setDisableRefresh(false);
    } else {
      setDisableBtnSearch(true);
      setDisableRefresh(true);
    }
  }, [inputValue, operationValue]);

  let location = useLocation();
  let recordIdFromRecent;

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (recordIdFromRecent !== undefined) {
      setFilteredData(recordIdFromRecent);
      setDisableBtnSearch(true);
      setDisableRefresh(false);
    } else {
      setDisableRefresh(true);
    }
  }, [recordIdFromRecent]);

  const DoNothing = () => {};

  return (
    <div>
      <div className="grid grid-cols-6 space-x-2">
        <div className="w-full col-span-2">
          <TextInput
            type={textInputName}
            name={textInputName}
            value={inputValue}
            placeholder={moduleDetails}
            onChange={(e) => {
              setInputValue(e.target.value);
              e.target.value === "" ? filterText("") : DoNothing();
            }}
          />
        </div>
        <div className="w-full col-span-2">
          <SelectHookFormSingleEmail
            options={operationsType}
            isDisabled={false}
            value={operationValue}
            onChange={(e) => {
              setOperationValue(e && e.label);
            }}
          />
        </div>
        <div className="flex flex-auto space-x-2">
          <SearchButton
            buttonValue="Search"
            className={
              disableBtnSearch ? "opacity-50 ml-2" : "opacity-100 ml-2"
            }
            disabled={disableBtnSearch}
            onClick={() => {
              FilterData();
            }}
          />
          <div>
            <RefreshButton
              className={
                filteredData === undefined && disableRefresh
                  ? "opacity-50"
                  : "opacity-100"
              }
              disabled={
                disableRefresh && filteredData === undefined ? true : false
              }
              onClick={() => {
                filterText("");
                filterOperation("");
                setInputValue("");
                setOperationValue(null);
                setNotifVal([]);
                setFilteredData(undefined);
                setDisableBtnSearch(true);
                setDisableRefresh(true);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
